import React from "react";

export default ({ style = {}, width, height, children, ...rest }) => {
  style.paddingTop = `${((100 * height) / width).toFixed(4)}%`;
  return (
    <div style={style} {...rest}>
      {children}
    </div>
  );
};
